import { queryOptions } from '@tanstack/react-query';

import { RQ_CMS_EXPLORE_PAGE, RQ_SHOP_DROP } from '../ReactQuery/cacheKeys';

import { getContentfulData } from './api';
import { createCMSExploreQuery } from './helpers/createCMSExplorePageQuery';
import { createShopDropQuery } from './helpers/createShopDropQuery';
import { transformCMSExplorePageResponse } from './helpers/transformCMSExplorePageResponse.ts';
import { transformShopDropResponse } from './helpers/transformShopDropResponse';
import {
  type CMSExplorePageResponse,
  type InfluencerDropResponse,
} from './types';

export function cmsExplorePageQueryOptions(slug: string, enabled = true) {
  const query = createCMSExploreQuery(slug);
  return queryOptions({
    queryKey: [RQ_CMS_EXPLORE_PAGE, slug],
    queryFn: async () => {
      const { data } = await getContentfulData<CMSExplorePageResponse>({
        query,
      });
      return transformCMSExplorePageResponse(data);
    },
    enabled,
  });
}

export function shopDropQueryOptions(username: string) {
  const query = createShopDropQuery(username);
  return queryOptions({
    queryKey: [RQ_SHOP_DROP, username],
    queryFn: async () => {
      const { data } = await getContentfulData<InfluencerDropResponse>({
        query,
      });
      return transformShopDropResponse(data);
    },
  });
}
